import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from 'react';

const SCROLL_EVENT_TYPE = 'scroll';

export function usePageScrolledWithTopBuffer(
  ref: React.RefObject<any>,
  topBuffer: number = 0
): boolean {
  const [isInBuffer, setIsInBuffer] = useState<boolean>(false);
  const [initialDistanceFromTop, setInitialDistanceFromTop] = useState<number>(
    Math.floor(ref?.current?.getBoundingClientRect().top)
  );
  const [initialElementHeight, setInitialElementHeight] = useState<number>(0);
  const [didScroll, setDidScroll] = useState(false);

  const handleScroll = useCallback(() => {
    const elementDistanceFromTop: number = Math.floor(
      ref?.current?.getBoundingClientRect().top
    );
    if (window.scrollY <= initialDistanceFromTop - initialElementHeight) {
      if (isInBuffer) {
        setIsInBuffer(false);
      }
    } else if (elementDistanceFromTop < topBuffer) {
      if (!isInBuffer) {
        setIsInBuffer(true);
      }
    }
  }, [
    ref,
    initialDistanceFromTop,
    initialElementHeight,
    topBuffer,
    isInBuffer,
  ]);

  useEffect(() => {
    if (!didScroll && ref?.current) {
      const elementBoundingClientRect = ref?.current?.getBoundingClientRect();
      setInitialDistanceFromTop(elementBoundingClientRect.top);
      setInitialElementHeight(elementBoundingClientRect.height);
      setDidScroll(true);
      handleScroll();
    }
  }, [didScroll, handleScroll, ref]);

  useLayoutEffect(() => {
    window.addEventListener(SCROLL_EVENT_TYPE, handleScroll);
    return () => window.removeEventListener(SCROLL_EVENT_TYPE, handleScroll);
  }, [isInBuffer, handleScroll]);

  return isInBuffer;
}
